import { SymbologyValues } from 'app/store/appSettings/AppSettingsState.ts';

export type DarkVenueHeatmapRequest = {
    symbol: string;
    symbology: SymbologyValues;
};

export const toUid = (r: DarkVenueHeatmapRequest) =>
    r.symbology + '/' + r.symbol;
